export const errors = {
  save: 'Ocorreu algum erro ao efetuar o cadastro',
  load: 'Ocorreu algum erro ao carregar as informações',
  update: 'Ocorreu algum erro ao atualizar as informações',
  delete: 'Não foi possível realizar a exclusão',
  requiredFields: 'Existem campos obrigatório que não foram preenchidos',
  requiredFilters: 'Preencha no mínimo um dos filtros',
  emptySearch: 'Nenhum registro localizado com o filtro informado',
  sendEmail: 'Ocorreu algum erro ao enviar o(s) e-mail(s)',
  userNotFound: 'Não foi possível localizar o usuário informado!',
  fileLimit: 'A solicitação não pode ter mais de 3 anexos',
  updateTable: 'Ocorreu algum erro ao atualizar a tabela',

  user: {
    userExist: 'Usuário já existente. Utilize outro nome de usuário',
    changePassword: 'Não foi possível alterar a senha do usuário',
    invalidLogin: 'Usuário ou senha inválidos'
  },

  company: {
    emptySearch: 'Não foi localizada nenhuma empresa'
  },

  regional: {
    emptySearch: 'Não foi localizada nenhuma regional para a empresa selecionada'
  },

  serviceLocal: {
    emptySearch: 'Não foi localizada nenhuma localidada para a regional e/ou empresa selecionada'
  }
};
